import React, {useEffect} from "react";
import {Card, CardBody, CardHeader, CardHeaderToolbar, ModalProgressBar,} from "../../../_metronic/_partials/controls";
import FactorsTable from "./FactorsTable";
import {useFactorsUIContext} from "./FactorsUIContext";
import {shallowEqual, useSelector} from "react-redux";
import {getFactors, getStatuses} from "./crud/factorCrud";
import {OrderEdit} from "./order-edit/OrderEdit";
import {useQuery} from "../../../_metronic/_helpers/SearchParams";

export default function FactorsListCmp() {

    const FactorContext = useFactorsUIContext();
    const {actionsLoading} = useSelector(
        (state) => ({
            actionsLoading: state.actionsLoading.actionsLoading,
        }),
        shallowEqual
    );

    let query = useQuery();

    useEffect(() => {
        // orderContext.fetchData(query.get("page") ? query.get("page") : 1, query.get("limit") ? query.get("limit") : '');
        FactorContext.fetchData();

    }, [query.get("page"), query.get("limit")]);

    useEffect(() => {
        getStatuses().then(response => {
            FactorContext.setStatuses(response.data.data);
        })
    }, []);

    useEffect(() => {
        getFactors().then(response => {
            FactorContext.setFactors(response.data.data);
        })
    }, []);

    return (
        <>
            {actionsLoading && <ModalProgressBar/>}
            <Card>
                <CardHeader title="لیست فاکتور ها">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-warning ml-2"
                            onClick={() => {
                                FactorContext.fetchData()
                            }}>
                            بارگزاری مجدد
                        </button>
                        <button
                            type="button"
                            className="btn btn-success ml-2"
                            onClick={() => {
                                window.location.href='/admin/factors/create'
                            }}>
                            ایجاد فاکتور
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    {FactorContext.data?.data &&
                    <FactorsTable
                        data={FactorContext.data}
                        activePage={query.get("page") ? query.get("page") : 1}
                    />
                    }

                    {FactorContext.openEdit &&
                    <OrderEdit
                        show={FactorContext.openEdit}
                        onHide={() => {
                            FactorContext.setOpenEdit(false);
                            FactorContext.fetchData();
                        }}
                        onSave={() => {
                            FactorContext.setOpenEdit(false);
                            FactorContext.fetchData()
                        }}
                    />
                    }

                </CardBody>
            </Card>
        </>
    )
}